
const Modal = ({ handleClose, show, children }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";

    return (
        <div className={showHideClassName}>
            <section className="modal-main">
                {children}
                <button className="r btn btn-outline-info btn-sm" type="button" onClick={handleClose}>
                    Close
                </button>
            </section>
        </div>
    );
};

export {Modal};